
import s from './navItem.module.css';
import t from '../../../../../../../../css/global.module.css';


function hideOnClassName(hideOn, otherClass) {
  let hideOnClass = '';
  if (hideOn) {
    switch (hideOn.toLowerCase()) {
      case 'phone':
        hideOnClass = t['helper_hide-BelowPhone'];
        break;
      case 'tablet':
        hideOnClass = t['helper_hide-BelowTablet'];
        break;
      case 'wide':
        hideOnClass = t['helper_hide-BelowWide'];
        break;
      case 'max':
        hideOnClass = t['helper_hide-BelowMax'];
        break;
      case 'desktop':
        hideOnClass = t['helper_show-BelowDesktop'];
        break;
      case 'Landscape':
        hideOnClass = t['helper_hide-BelowLandscape'];
        break;
      default:
        hideOnClass = '';
        break;
    }
  }

  return `${s.root} ${hideOnClass} ${otherClass ? s[otherClass] : ''}`;
}

export { hideOnClassName };
